import pick from 'lodash/pick';
import merge from 'lodash/merge';
import get from 'lodash/get';

import formClientConstants from './constants';

const initialState = {
  isInitializing: false,
  isError: false,
  isSubmitting: false,
  isSubmitted: false,
  submitErrorMessage: '',
  formId: '',
  userName: '',
  teamName: '',
  companyName: '',
  privacy: '',
  headerImage: '',
  confirmationText: '',
  buttonLabel: 'Submit',
  buttonColor: '',
  JSONSchema: {
    title: '',
    properties: {}
  },
  UISchema: {
    'ui:order': []
  }
};

const formClientReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case formClientConstants.INITIALIZE_FORM_CLIENT:
      return merge({}, state, { isInitializing: true });

    case formClientConstants.INITIALIZE_FORM_CLIENT_SUCCESS:
    {
      const {
        form
      } = payload;

      const updatedState = pick(form, ['JSONSchema', 'UISchema', 'privacy', 'headerImage', 'confirmationText', 'buttonLabel', 'buttonColor']);
      updatedState.isInitializing = false;
      updatedState.isError = false;
      updatedState.isSubmitted = false;
      updatedState.submitErrorMessage = '';
      updatedState.formId = form.id;
      updatedState.userName = get(window, '__INITIAL_DATA__.user.name');
      updatedState.teamName = get(window, '__INITIAL_DATA__.user.team.name');
      updatedState.companyName = get(window, '__INITIAL_DATA__.user.organization.name');

      return merge({}, state, updatedState);
    }

    case formClientConstants.INITIALIZE_FORM_CLIENT_ERROR:
      return merge({}, state, { isInitializing: false, isError: true });

    case formClientConstants.SUBMIT_FORM:
      return merge({}, state, { isSubmitting: true, submitErrorMessage: '' });

    case formClientConstants.SUBMIT_FORM_SUCCESS:
      return merge({}, state, { isSubmitting: false, isSubmitted: true, submitErrorMessage: '' });

    case formClientConstants.SUBMIT_FORM_ERROR:
      return merge({}, state, { isSubmitting: false, submitErrorMessage: payload.message });

    default:
      return state;
  }
};

export default formClientReducer;
